import { apiClient } from '../../../api/interceptor';
import { API_ROUTES } from './constants';

// customer CRUD
export const getCustomerInfo = ({ id }) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_INFO.METHOD,
    url: `${API_ROUTES.CUSTOMER_INFO.URL}/${id}`,
  });
};

export const customerList = (data) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_LIST.METHOD,
    url: API_ROUTES.CUSTOMER_LIST.URL,
    data,
  });
};
export const customerAdd = (data) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_ADD.METHOD,
    url: API_ROUTES.CUSTOMER_ADD.URL,
    data,
  });
};
export const changeStatus = ({ id, data }) => {
  return apiClient({
    method: API_ROUTES.CHANGE_STATUS.METHOD,
    url: `customer/${id}/${API_ROUTES.CHANGE_STATUS.URL}`,
    data,
  });
};
export const customerUpdate = ({ id, data }) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_UPDATE.METHOD,
    url: `${API_ROUTES.CUSTOMER_UPDATE.URL}/${id}`,
    data,
  });
};
export const customerDelete = ({ id }) => {
  return apiClient({
    method: API_ROUTES.CUSTOMER_DELETE.METHOD,
    url: `${API_ROUTES.CUSTOMER_DELETE.URL}/${id}`,
  });
};
